import { FC } from 'react';
import { MdInfoOutline } from '@react-icons/all-files/md/MdInfoOutline';
import classNames from 'classnames';
import useSWR from 'swr';

import { ContentLoader } from 'components/design-system/ContentLoader';
import { useModal } from 'context/modal/ModalContext';
import { clientApiGet } from 'lib/api_helper';
import styles from 'styles/Auctions.module.scss';
import { AuctionConfig } from 'types/auction';

import { BuyersPremiumSlideout } from './Modals/BuyersPremiumSlideout/BuyersPremiumSlideout';

type BuyersPremiumInfoProps = {
  className?: string;
  isDark?: boolean;
  showFeeInTheEnd?: boolean;
};

export const BuyersPremiumInfo: FC<BuyersPremiumInfoProps> = ({ className, isDark, showFeeInTheEnd }) => {
  const { data: buyersPremium, isLoading: buyersPremiumLoading } = useSWR<AuctionConfig>(
    '/api/marketplace/configs/live',
    clientApiGet
  );
  const { closeModal, openModal } = useModal();

  const openBuyersPremiumSlideout = (buyersPremiumValue: AuctionConfig) =>
    openModal(<BuyersPremiumSlideout isDark={isDark} {...buyersPremiumValue} closeModal={closeModal} />, true);

  if (buyersPremiumLoading || !buyersPremium) {
    return <ContentLoader className='w-50' isDark={isDark} width={150} height={18} />;
  }

  const buyersPremiumBips = buyersPremium.buyersPremiumPromotionBips ?? buyersPremium.buyersPremiumBips;
  const auctionFee = `(${buyersPremiumBips / 100})`;
  const hasPromotion = typeof buyersPremium.buyersPremiumPromotionBips === 'number';

  return (
    <span
      role='button'
      className={classNames(className, isDark ? styles.buyersPremiumButtonDark : styles.buyersPremiumButtonLight)}
      onClick={() => openBuyersPremiumSlideout(buyersPremium)}
    >
      <div className='d-flex justify-content-between'>
        <div>
          {buyersPremiumBips === 0 && !showFeeInTheEnd
            ? 'No auction fee'
            : `Auction fee ${showFeeInTheEnd ? '' : auctionFee}`}
          <span style={{ bottom: 1 }} className='position-relative'>
            {' '}
            <MdInfoOutline size={16} />
          </span>
        </div>
        {showFeeInTheEnd && (
          <span className='text-secondary'>
            {hasPromotion && (
              <span className='text-light'>
                {typeof buyersPremium.buyersPremiumPromotionBips === 'number'
                  ? buyersPremium.buyersPremiumPromotionBips / 100 + '%'
                  : undefined}{' '}
              </span>
            )}
            <span className={classNames({ 'text-decoration-line-through': hasPromotion })}>
              {buyersPremium.buyersPremiumBips / 100 + '%'}
            </span>
          </span>
        )}
      </div>
    </span>
  );
};
